import { combineReducers } from '@reduxjs/toolkit'

import assetReducer from './asset-assign'
import needAttentionReducer from './need-attention'

const combinedReducer = combineReducers({
  assetManagement: assetReducer,
  needsAttention: needAttentionReducer,
})

export default combinedReducer